import { FormFieldDto } from '../../general/dtos';

export interface QuizTargetDisplay {
    fieldKey: string;
    expectedKey: string;
    label: string;
}

export function quizItemLabel(field: FormFieldDto, index: number, label = ''): string {
    return `${field.label.trim() || 'Quiz'} — ${label.trim() || `Item ${index}`}`;
}

/** A target's label belongs to its insertion, not to neighbouring text or the answer pool. */
export function quizTargetDisplays(fields: FormFieldDto[], html = ''): QuizTargetDisplay[] {
    const doc = new DOMParser().parseFromString(html, 'text/html');
    const pools = new Map(fields.filter(field => field.type === 'quiz-list').map(field => [field.key, field]));
    const counts = new Map<string, number>();
    return Array.from(doc.querySelectorAll('quiz-target')).flatMap(node => {
        const fieldKey = node.getAttribute('field-key') ?? '';
        const expectedKey = node.getAttribute('expected-key');
        const field = pools.get(fieldKey);
        if (!field || !expectedKey) return [];
        const index = (counts.get(fieldKey) ?? 0) + 1;
        counts.set(fieldKey, index);
        return [{ fieldKey, expectedKey, label: quizItemLabel(field, index, node.getAttribute('results-label') ?? '') }];
    });
}
